import { render } from "./GiftNew.vue?vue&type=template&id=176adaf8&scoped=true"
import script from "./GiftNew.vue?vue&type=script&lang=js"
export * from "./GiftNew.vue?vue&type=script&lang=js"

import "./GiftNew.vue?vue&type=style&index=0&id=176adaf8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176adaf8"]])

export default __exports__